var React = require('react');

function Xmark (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.2124 5L19.0001 18.7816","stroke":"black","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M18.7876 5L4.99991 18.7816","stroke":"black","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Xmark.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = Xmark;

Xmark.default = Xmark;
